import BaseModelAPI from '../BaseModelAPI';

export default class DataSourceList extends BaseModelAPI {

	static entity = 'datasourcelist'
	static entityName = 'datasource';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
